import Vue from 'vue'
import EventBus from '@/plugins/EventBus'

const signalR = require('@aspnet/signalr')

export default {
  connection: null,
  start(conviteId: string) {
    const env: any = window
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${env.API_FINX_SIGNALR}${conviteId}`)
      .configureLogging(signalR.LogLevel.Information)
      .build()

    // @ts-ignore
    this.connection.start().then(() => {

    })

    // @ts-ignore
    this.connection.on('assinaturaAdicionada', (action: any) => {
      EventBus.$emit('loadImageAssinatura', action)
    })
  },
}
